import UpgradePage from './UpgradePage'

export default UpgradePage
